module.exports = __webpack_public_path__ + "img/dev-heroes-1.014386ec.jpg";